import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Agent, Flex, LocationPin } from '@zazume/zzm-base';

import { AgentSearch } from '#/models/algolia/AgentSearch';
import { AgentTagsList } from '#/pages/people/agent/components/atoms/AgentTagsList';

import { ResultGoToItem, ResultItemBase } from './ResultItem';

const LinkContainer = styled.a(({ theme }) => css``);

const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
  `
);

const SmallDetails = styled.div`
  font-size: 12px;
`;

const AreasContainer = styled.div(
  ({ theme }) => css`
    text-transform: capitalize;
    display: flex;
    align-items: center;
    gap: ${theme.spacing.s2};
  `
);

export const AgentCell: ResultItemBase<{}> = ({ hit, components }) => {
  const agentSearch = hit as any as AgentSearch;
  const serviceAreas = agentSearch.serviceAreas;
  const tags = agentSearch.tags;

  return (
    <LinkContainer href={ResultGoToItem(hit)} className="aa-ItemLink">
      <Container className="aa-ItemContent">
        <Agent color="Gray600" />
        <div className="aa-ItemTitle">
          <components.Highlight hit={hit} attribute="name" />
          {Boolean(tags?.length) && <AgentTagsList tags={tags} direction="row" />}
          <SmallDetails>
            <components.Highlight hit={hit} attribute="email" />
          </SmallDetails>
          <SmallDetails>
            <Flex gap="xs">
              <components.Highlight hit={hit} attribute="phoneNumber" />
              {Boolean(serviceAreas?.length) && (
                <AreasContainer>
                  <LocationPin scale="xs" color="Gray500" />
                  {serviceAreas.map((_, i) => (
                    <SmallDetails>
                      <components.Highlight hit={hit} attribute={['serviceAreas', i]} />
                    </SmallDetails>
                  ))}
                </AreasContainer>
              )}
            </Flex>
          </SmallDetails>
        </div>
      </Container>
    </LinkContainer>
  );
};
